module.exports = __webpack_public_path__ + "static/img/przybornik_wielkosc3.2a8e8a09.png";